import React, { useState, useEffect } from "react";
import NoteForm from "./components/NoteForm";
import NotesList from "./components/NotesList";
import "./App.css";

function App() {
  const [notes, setNotes] = useState([]);
  const [search, setSearch] = useState("");

  // Load from localStorage
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("notes"));
    if (data) setNotes(data);
  }, []);

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem("notes", JSON.stringify(notes));
  }, [notes]);

  // Add Note
  const addNote = (text) => {
    const newNote = {
      id: Date.now(),
      text,
      pinned: false,
    };
    setNotes([newNote, ...notes]);
  };

  // Delete Note
  const deleteNote = (id) => {
    setNotes(notes.filter((note) => note.id !== id));
  };

  // Edit Note
  const editNote = (id, newText) => {
    setNotes(
      notes.map((note) =>
        note.id === id ? { ...note, text: newText } : note
      )
    );
  };

  // Toggle Pin
  const togglePin = (id) => {
    setNotes(
      notes.map((note) =>
        note.id === id ? { ...note, pinned: !note.pinned } : note
      )
    );
  };

  // Filter + Sort
  const filteredNotes = notes
    .filter((note) =>
      note.text.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => b.pinned - a.pinned);

  return (
    <div className="app">
      <h1>📝 Notes App</h1>

      <NoteForm addNote={addNote} />

      {/* Search Bar */}
      <input
        type="text"
        placeholder="🔍 Search notes..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <NotesList
        notes={filteredNotes}
        deleteNote={deleteNote}
        editNote={editNote}
        togglePin={togglePin}
      />
    </div>
  );
}

export default App;